import { Component, input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { createMask, InputMaskModule } from '@ngneat/input-mask';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface CustomError {
  errorKey: string;
  message: string;
}

@Component({
  selector: 'adm-price-unit-input',
  imports: [ReactiveFormsModule, InputMaskModule, MatFormFieldModule, MatInputModule],
  templateUrl: './price-unit-input.component.html',
  styleUrl: './price-unit-input.component.scss',
})
export class PriceUnitInputComponent implements OnInit {
  control = input.required<FormControl<number | null>>();
  label = input.required<string>();
  hint = input<string | null>(null);
  maxPrice = input(999.99);

  // In case of multiple custom errors in the future, add a second input like customErrors2
  // mat-error did not like having CustomError[] as an array, as the @for interacts badly with mat-form-field for some reason...
  customError = input<CustomError | null>(null);

  priceInputMask = createMask({
    alias: 'numeric',
    placeholder: '',
    digits: 2,
    min: 0,
    groupSeparator: '',
    radixPoint: ',',
    rightAlign: false,
    parser: (value: string) => {
      const parsed = parseFloat(value.replace(',', '.'));
      return isNaN(parsed) ? null : parsed;
    },
  });

  ngOnInit(): void {
    const control = this.control();
    control.addValidators([Validators.min(0), Validators.max(this.maxPrice())]);
    control.updateValueAndValidity();
  }
}
